<template>
  <div class="form-column-ruler">
    <i class="fas fa-arrows-alt-h form-column-ruler__icon"></i>
    <label class="form-column-ruler__label" :for="inputId">{{ $t('Column width') }}</label>
    <input
      :id="inputId"
      type="range"
      class="form-column-ruler__slider"
      :min="min"
      :max="max"
      step="5"
      :value="current || autoWidth"
      @input="onSlide($event.target.value)"
    />
    <span class="form-column-ruler__value">{{ current ? current + 'px' : $t('Automatic') }}</span>
    <button type="button" class="btn btn-sm btn-link" @click="reset">{{ $t('Fill the whole width') }}</button>
    <button type="button" class="btn btn-sm btn-outline-secondary" @click="$emit('cancel')">{{ $t('Cancel') }}</button>
    <button type="button" class="btn btn-sm btn-primary" @click="$emit('done', current)">{{ $t('Done') }}</button>
  </div>
</template>

<script>
// Deslizador arriba del formulario para el ancho de las columnas: uno solo,
// porque todas miden lo mismo. Puede pasar el ancho de la pantalla (el
// formulario se desplaza de costado). Emite `input` con los px en vivo (la
// página redibuja la grilla) y `done` con el ancho final para guardar;
// null = repartir el ancho del formulario.
export default {
  name: "FormColumnRuler",
  props: {
    columns: { type: Number, required: true },
    value: { type: Number, default: null },
  },
  data() {
    return {
      current: this.value,
      min: 80,
      max: 800,
      autoWidth: 200,
      inputId: `form-column-width-${Math.random().toString(36).slice(2, 8)}`,
    };
  },
  mounted() {
    // Sin ancho guardado, el deslizador arranca en lo que mide hoy cada columna.
    const width = this.$el.getBoundingClientRect().width;
    if (width && this.columns) {
      this.autoWidth = Math.min(this.max, Math.max(this.min, Math.round(width / this.columns)));
    }
  },
  methods: {
    onSlide(raw) {
      this.current = Number(raw);
      this.$emit("input", this.current);
    },
    reset() {
      this.current = null;
      this.$emit("input", null);
    },
  },
};
</script>

<style scoped>
/* La grilla de columnas solo corre desde 768px: en el teléfono no sirve. */
@media (max-width: 767.98px) {
  .form-column-ruler {
    display: none !important;
  }
}

.form-column-ruler {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 20;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
  max-width: calc(100vw - 8rem);
  margin-bottom: 0.5rem;
  padding: 0.45rem 0.75rem;
  background-color: var(--bs-body-bg);
  border: 1px dashed rgba(var(--bs-primary-rgb), 0.5);
  border-radius: 8px;
}

.form-column-ruler__icon {
  color: var(--bs-primary);
}

.form-column-ruler__label {
  margin: 0;
  font-size: 0.85rem;
  font-weight: 600;
}

.form-column-ruler__slider {
  flex: 1 1 14rem;
  min-width: 10rem;
  max-width: 28rem;
  accent-color: var(--bs-primary);
  cursor: ew-resize;
}

.form-column-ruler__value {
  min-width: 4.5rem;
  font-size: 0.85rem;
  font-variant-numeric: tabular-nums;
  color: var(--bs-secondary-color);
}
</style>
